export default "__VITE_ASSET__BQfoe5VM__"